module.exports = __webpack_public_path__ + "static/wsporniki_rur_relingowych-d0866ffb338194b2ca101bd85c29ce29.pdf";